import { Styles } from '@chakra-ui/theme-tools';

const styles: Styles = {
  global: {
    '*': {
      _focusVisible: {
        outline: '0 !important',
      },
    },
    // Reskin: mockup base text is 14px (--text-base). Keep the 16px root (so
    // rem spacing is unaffected) and set the body default to 14px. Headings use
    // the larger fontSizes scale (see theme `fontSizes`). Font family is owned
    // by the theme (body = Plus Jakarta Sans, headings = Space Grotesk).
    body: {
      fontFamily: 'body',
      fontSize: 'base',
      color: 'text.default',
      bg: 'bg.canvas',
    },
    // (removed legacy `th { font-family: inter !important }` — DS table theme
    //  now owns thead styling; the !important was fighting the DS font.)
  },
};

export default styles;
